'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import ContentRoutes from 'ContentUtils/Routes';
import { CREATED_AND_USED_IN_LIST } from '../actions/ActionTypes';
import { requestCreateAndUseInList, requestedCreateAndUseInListFailure, requestedCreateAndUseInListSuccess } from '../actions/ListsActions';
import { closeModal } from '../actions/ModalActions';
export default ((action$, _, {
  ListsClient
}) => action$.ofType(CREATED_AND_USED_IN_LIST).pipe(mergeMap(({
  payload: {
    contentType,
    data,
    name
  }
}) => ListsClient.create(name).pipe(mergeMap(({
  listId
}) => ListsClient.exportToList(data, listId).pipe(mergeMap(() => of(closeModal(), requestedCreateAndUseInListSuccess(contentType, ContentRoutes.list(listId)))), catchError(error => of(requestedCreateAndUseInListFailure(error, contentType))))), catchError(error => of(requestedCreateAndUseInListFailure(error, contentType))), startWith(requestCreateAndUseInList())))));